import AWS from 'aws-sdk'
import {AuthenticationDetails, CognitoUser, CognitoUserAttribute, CognitoUserPool} from 'amazon-cognito-identity-js'
import {apiGatewayClient, getApiGatewayClient, initApiGatewayClient} from './api'
import {clearSubscriptions} from './api-catalog'
import DeveloperPortalConfiguration from "./DeveloperPortalConfiguration";

const poolData = {
    UserPoolId: DeveloperPortalConfiguration.cognitoUserPoolId,
    ClientId: DeveloperPortalConfiguration.cognitoClientId
};

let cognitoUser;
let userPool;

export function isAuthenticated() {
    return !!cognitoUser;
}

function getCognitoLoginKey() {
    return `cognito-idp.${DeveloperPortalConfiguration.cognitoRegion}.amazonaws.com/${DeveloperPortalConfiguration.cognitoUserPoolId}`
}

export function init() {
    // attempt to refresh credentials from active session
    userPool = new CognitoUserPool(poolData);
    cognitoUser = userPool.getCurrentUser();

    if (cognitoUser !== null) {
        cognitoUser.getSession(function (err, session) {
            if (err) {
                logout();
                console.error(err);
                return;
            }

            const cognitoLoginKey = getCognitoLoginKey();
            const Logins = {};
            Logins[cognitoLoginKey] = session.getIdToken().getJwtToken();
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                IdentityPoolId: DeveloperPortalConfiguration.cognitoIdentityPoolId,
                Logins: Logins
            });

            AWS.config.credentials.refresh((error) => {
                if (error) {
                    logout();
                } else {
                    initApiGatewayClient(AWS.config.credentials)
                }
            })
        })
    } else {
        initApiGatewayClient()
    }
}

export function register(email, password, company) {
    localStorage.clear();
    const attributeList = [];

    const companyData = {
        Name: "custom:company",
        Value: company
    };

    const companyAttribute = new CognitoUserAttribute(companyData);
    attributeList.push(companyAttribute);

    return new Promise((resolve, reject) => {
        userPool.signUp(email, password, attributeList, null, (err, result) => {
            if (err) {
                reject(err)
            } else {
                resolve(login(email, password))
            }
        })
    })
}

export function login(email, password) {
    const authenticationData = {
        Username: email,
        Password: password
    };
    const authenticationDetails = new AuthenticationDetails(authenticationData);
    userPool = new CognitoUserPool(poolData);
    const userData = {
        Username: email,
        Pool: userPool
    };

    cognitoUser = new CognitoUser(userData);
    return new Promise((resolve, reject) => {
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: (result) => {
                const cognitoLoginKey = getCognitoLoginKey();
                const Logins = {};
                Logins[cognitoLoginKey] = result.getIdToken().getJwtToken();
                AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: DeveloperPortalConfiguration.cognitoIdentityPoolId,
                    Logins: Logins
                });

                AWS.config.credentials.refresh((error) => {
                    if (error) {
                        console.error(error)
                    } else {
                        initApiGatewayClient(AWS.config.credentials);

                        getApiGatewayClient().then(apiGatewayClient => {
                            apiGatewayClient.post('/api/signin', {}, {}, {}).then((result) => {
                                resolve(result)
                            }).catch((err) => {
                                console.error("Error posting to api/signin" + JSON.stringify(err));
                                reject(err)
                            })
                        })
                    }
                })
            },

            onFailure: (err) => {
                reject(err)
            }
        })
    })
}

export function logout() {
    cognitoUser.signOut();
    cognitoUser = null;
    clearSubscriptions();
    localStorage.clear()
}

export function showApiKey() {
    return apiGatewayClient.get('/api/apikey', {}, {}, {}).then(({data}) => data.value)
}



/** WEBPACK FOOTER **
 ** ./src/services/self.js
 **/